export class StandardOption<T> {
  constructor(
    public label: string,
    public value: T,
    public description: string = ""
  ) {
  }
}
